import React, { ReactNode } from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
  openImageViewer?: (imageUrl: string) => void; // New prop
  imageUrl?: string; // New prop
}

function Card({
  children,
  className = '',
  hover = false,
  onClick,
  openImageViewer,
  imageUrl
}: CardProps) {
  const baseClasses = 'rounded-xl border border-gray-200 transition-all duration-300';
  const hoverClasses = hover ? 'hover:shadow-elegant hover:-translate-y-1 cursor-pointer' : '';

  return (
    <div className={`${baseClasses} ${hoverClasses} ${className}`} onClick={onClick}>
      {children}
      {openImageViewer && imageUrl && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
          <button
            className="text-white p-2 rounded-full bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            onClick={() => openImageViewer(imageUrl)}
          >
            View Image
          </button>
        </div>
      )}
    </div>
  );
};

export default Card;